/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseFinancialRefreshTokenResponse } from '../models/ApiResponseFinancialRefreshTokenResponse';
import type { ApiResponseFinancialTokenResponse } from '../models/ApiResponseFinancialTokenResponse';
import type { ApiResponseHcsResponse } from '../models/ApiResponseHcsResponse';
import type { CreateFinancialTokenRequest } from '../models/CreateFinancialTokenRequest';
import type { IssueFinancialTokenRequest } from '../models/IssueFinancialTokenRequest';
import type { RefreshAndRevokeTokenRequest } from '../models/RefreshAndRevokeTokenRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FinancialTokenManagementControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * HCS 토큰체크
   * HCS 토큰 유효성을 확인합니다.
   * @returns ApiResponseHcsResponse OK
   * @throws ApiError
   */
  public validateFinancialToken({
    requestBody,
  }: {
    requestBody: RefreshAndRevokeTokenRequest,
  }): CancelablePromise<ApiResponseHcsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token/validation',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 토큰체크
   * HCS 토큰 유효성을 확인합니다.
   * @returns ApiResponseHcsResponse OK
   * @throws ApiError
   */
  public validateFinancialToken1({
    requestBody,
  }: {
    requestBody: RefreshAndRevokeTokenRequest,
  }): CancelablePromise<ApiResponseHcsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token/validation/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 토큰폐기
   * HCS 토큰을 폐기합니다.
   * @returns ApiResponseHcsResponse OK
   * @throws ApiError
   */
  public revokeFinancialToken({
    requestBody,
  }: {
    requestBody: RefreshAndRevokeTokenRequest,
  }): CancelablePromise<ApiResponseHcsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token/revoke/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 토큰폐기
   * HCS 토큰을 폐기합니다.
   * @returns ApiResponseHcsResponse OK
   * @throws ApiError
   */
  public revokeFinancialToken1({
    requestBody,
  }: {
    requestBody: RefreshAndRevokeTokenRequest,
  }): CancelablePromise<ApiResponseHcsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token/revoke',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 토큰갱신
   * HCS 토큰을 갱신합니다.
   * @returns ApiResponseFinancialRefreshTokenResponse OK
   * @throws ApiError
   */
  public refreshFinancialToken({
    requestBody,
  }: {
    requestBody: RefreshAndRevokeTokenRequest,
  }): CancelablePromise<ApiResponseFinancialRefreshTokenResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token/refresh',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 토큰갱신
   * HCS 토큰을 갱신합니다.
   * @returns ApiResponseFinancialRefreshTokenResponse OK
   * @throws ApiError
   */
  public refreshFinancialToken1({
    requestBody,
  }: {
    requestBody: RefreshAndRevokeTokenRequest,
  }): CancelablePromise<ApiResponseFinancialRefreshTokenResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token/refresh/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 토큰발행(FE)
   * HCS 토큰을 발행합니다.(FE)
   * @returns ApiResponseFinancialTokenResponse OK
   * @throws ApiError
   */
  public issueFinancialToken({
    requestBody,
    xForwardedFor,
  }: {
    requestBody: IssueFinancialTokenRequest,
    xForwardedFor?: string,
  }): CancelablePromise<ApiResponseFinancialTokenResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token/issue/',
      headers: {
        'X-Forwarded-For': xForwardedFor,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 토큰발행(FE)
   * HCS 토큰을 발행합니다.(FE)
   * @returns ApiResponseFinancialTokenResponse OK
   * @throws ApiError
   */
  public issueFinancialToken1({
    requestBody,
    xForwardedFor,
  }: {
    requestBody: IssueFinancialTokenRequest,
    xForwardedFor?: string,
  }): CancelablePromise<ApiResponseFinancialTokenResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token/issue',
      headers: {
        'X-Forwarded-For': xForwardedFor,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 토큰발행
   * HCS 토큰을 발행합니다.
   * @returns ApiResponseFinancialTokenResponse OK
   * @throws ApiError
   */
  public createFinancialToken({
    requestBody,
  }: {
    requestBody: CreateFinancialTokenRequest,
  }): CancelablePromise<ApiResponseFinancialTokenResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 토큰발행
   * HCS 토큰을 발행합니다.
   * @returns ApiResponseFinancialTokenResponse OK
   * @throws ApiError
   */
  public createFinancialToken1({
    requestBody,
  }: {
    requestBody: CreateFinancialTokenRequest,
  }): CancelablePromise<ApiResponseFinancialTokenResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/token',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * HCS 서버상태 확인
   * HCS 서버상태를 확인합니다.
   * @returns ApiResponseHcsResponse OK
   * @throws ApiError
   */
  public revokeFinancialToken2({
    puid,
  }: {
    puid: string,
  }): CancelablePromise<ApiResponseHcsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/financial/v1/status/',
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * HCS 서버상태 확인
   * HCS 서버상태를 확인합니다.
   * @returns ApiResponseHcsResponse OK
   * @throws ApiError
   */
  public revokeFinancialToken3({
    puid,
  }: {
    puid: string,
  }): CancelablePromise<ApiResponseHcsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/financial/v1/status',
      query: {
        'puid': puid,
      },
    });
  }
}
